import type { Subscription, SubscriptionGroup } from "@/models/subscription";
import type { User } from "@/models/user";
import { API_BASE, type APIResponse, callApi } from "@/services/api";

export interface SubscriptionCreationArgs {
  planId: number;
  planCode: string;
  userId: number;
  source: "web" | "ios" | "stripe";
  provider: "stripe" | "apple" | "google";
  paymentToken: string;
  paymentIntentToken?: string | null;
  setupIntentToken?: string | null;
  couponCodes?: string[] | null;
  referralCode?: string | null;
  campaignCid?: string | null;
  subscriptionGroup?: Partial<SubscriptionGroup> | null;
  flags?: Record<string, boolean>;
  metaId?: string | null;
  segmentAttributes?: Record<string, string>;
}

export interface SubscriptionResponse extends Subscription {
  subscriptionGroupRole?: string | null;
  user?: Partial<User>;
}

export interface changePlanArgs {
  subscriptionId: number;
  planId: number;
  couponCodes?: string[] | null;
}

export async function subscribe(
  opts: SubscriptionCreationArgs,
): Promise<APIResponse<SubscriptionResponse>> {
  try {
    const resp = await callApi<SubscriptionResponse>(
      `${API_BASE}/subscriptions`,
      {
        method: "POST",
        body: opts,
      },
    );
    return resp;
  } catch (e) {
    throw e;
  }
}

export async function updatePlan({
  subscriptionId,
  planId,
  couponCodes,
}: changePlanArgs): Promise<APIResponse<Subscription>> {
  try {
    const resp = await callApi<Subscription>(
      `${API_BASE}/subscriptions/${subscriptionId}`,
      {
        method: "PUT",
        body: { planId, couponCodes },
      },
    );
    return resp;
  } catch (e) {
    throw e;
  }
}
